interface CardProps {
  children: React.ReactNode;
  dark?: boolean;
  hover?: boolean;
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
}

export function Card({ children, dark, hover, className, style, onClick }: CardProps) {
  const cls = [
    dark ? "card-dark" : "card",
    hover ? (dark ? "" : "card-hover") : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <div className={cls} style={style} onClick={onClick}>
      {children}
    </div>
  );
}

interface FeatureCardProps {
  icon?: React.ReactNode;
  title: string;
  description: string;
  dark?: boolean;
}

export function FeatureCard({ icon, title, description, dark }: FeatureCardProps) {
  return (
    <Card dark={dark} hover>
      {icon && (
        <div
          style={{
            width: "48px",
            height: "48px",
            borderRadius: "var(--radius-md)",
            background: dark ? "rgba(61,220,151,0.1)" : "var(--accent-50)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "1rem",
            color: "var(--accent-500)",
          }}
        >
          {icon}
        </div>
      )}
      <h3
        style={{
          fontSize: "1.125rem",
          marginBottom: "0.5rem",
          color: dark ? "var(--text-on-dark)" : "var(--text)",
        }}
      >
        {title}
      </h3>
      <p style={{ color: dark ? "var(--text-muted-on-dark)" : "var(--text-muted)", fontSize: "0.9375rem" }}>
        {description}
      </p>
    </Card>
  );
}
